import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d034766")

_pushScopeId("data-v-2d034766")
const _hoisted_1 = { class: "login_qrcode flex_centers" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QrcodeVue = _resolveComponent("QrcodeVue")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.viewModel.retry)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          style: { width: _ctx.size || 180 + 'px', height: _ctx.size || 180 + 'px' },
          class: "qrcode"
        }, [
          (_ctx.viewModel.qrText)
            ? (_openBlock(), _createBlock(_component_QrcodeVue, {
                key: 0,
                size: _ctx.size || 180,
                value: _ctx.viewModel.qrText,
                level: "H"
              }, null, 8, ["size", "value"]))
            : _createCommentVNode("", true)
        ], 4))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: "qrcode_fail",
          style: { width: _ctx.size || 180 + 'px', height: _ctx.size || 180 + 'px' },
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadLoginQrCode && _ctx.loadLoginQrCode(...args)))
        }, null, 4))
  ]))
})